import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select";
import ParcelTable from "./ParcelTable"
import CreateParcelModel from "./CreateParcelModel"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import { exportDataExcel } from "components/Common/ExportData"
import ParcelImagesUploadModel from "./ParcelImagesUploadModel"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

function ParcelList() {
    document.title = `Parcel | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [statusValue, setStatusValue] = useState(0)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [parcelData, setparcelData] = useState()
    const [isEdit, setIsEdit] = useState(false)
    const [imageModal, setImageModal] = useState(false)

    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const ParcelListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Parcel/list", {
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
            CreatedBy: parseInt(userFilter),
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.ParcelList)
                setTotalRecords(data.TotalRecords)
                setTotalAmount(data.TotalAmount)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            ParcelListApi()
        }

    }, [searchText, displayStart, rowsPerPage, userFilter, dateDisble, dateFilter])


    // Create task-title handler
    const handleParcelClick = () => {
        setIsEdit(false)
        setparcelData(null)
        toggle()
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // validation.handleReset()
    }

    const handleParcelIsDone = (id, e) => {
        if (id) {
            getApi(`Parcel/parcelIsDone?id=${id}`).then(({ data, status }) => {
                // e.preventDefault()
                if (status === 200) {
                    toast.success("Parcel done", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                    ParcelListApi()
                } else {
                    ErrorModel.errormodel({
                        title: "Verify Parcel",
                        text: data,
                    })
                }
            })
        }
    }

    const handleEdit = (data) => {
        setIsEdit(true)
        setparcelData(data)
        setModal(!modal)
    }
    const imageToggle = () => {
        setImageModal(!imageModal)
        // validation.handleReset()
    }

    const handleUploadImage = (data) => {
        setparcelData(data)
        imageToggle()
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
            },
            {
                Header: "Courier Partner",
                accessor: "CourierPartner",
            },
            {
                Header: "Amount",
                accessor: "Amount",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.Amount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "10%"
            },
            {
                Header: "Qty",
                accessor: "Qty",
                width: "4%",
                Cell: ({ row }) => (
                    <p className=" mb-0" style={{ display: "flex", justifyContent: "center" }}>
                        {row.original.Qty}
                    </p>
                ),
            },
            {
                Header: "Pay/Due",
                accessor: "PayOrDue",
                width: "6%",
                Cell: ({ row }) => (
                    <p className=" mb-0" style={{ display: "flex", justifyContent: "center" }}>
                        {row.original.PayOrDue ? "Pay" : "Due"}
                    </p>
                ),
            },
            {
                Header: "Levana/Devana",
                accessor: "LevanuOrDevanu",
                width: "6%",
                Cell: ({ row }) => (
                    <p className=" mb-0" style={{ display: "flex", justifyContent: "center" }}>
                        {row.original.LevanuOrDevanu ? "Levana" : !row.original.LevanuOrDevanu ? "Devana" : "N/A"}
                    </p>
                ),
            },
            {
                Header: "Remark",
                accessor: "Remark",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Remark}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original.CreatedOn.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <>
                            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                                <li className="mytooltip">
                                    {row.original.IsDone ?
                                        <Button
                                            task-title="secondary"
                                            className="btn btn-primary btn-sm "
                                            color="secondary"
                                        >
                                            Is Done
                                        </Button>
                                        : <Button
                                            color="primary"
                                            task-title="primary"
                                            className="btn btn-primary btn-sm "
                                            onClick={(e) => {
                                                handleParcelIsDone(row.original.Id, row.original.IsDone, e)

                                            }}
                                        >
                                            Is Done
                                        </Button>
                                    }
                                </li>
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        id={`edittooltip${row.original.Id}`}
                                        onClick={() => handleEdit(row.original)}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                                <li className="mytooltip">
                                    <i
                                        className=" fs-5 fas fa-cloud-upload-alt"
                                        id={`edittooltip${row.original.Id}`}
                                        onClick={() => handleUploadImage(row.original)}
                                    ></i>
                                    <span className="mytext">Upload Images</span>
                                </li>

                            </ul>
                        </>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "Courier Partner", "Amount", "Created By", "Qty", "Pay/Due", "Remark", "Created On"];
            const mainTitle = "Parcel";
            const widthObj = [{
                Key: "A",
                Value: 15,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 10,
            },
            {
                Key: "D",
                Value: 15,
            },
            {
                Key: "E",
                Value: 5,
            },
            {
                Key: "F",
                Value: 8,
            },
            {
                Key: "G",
                Value: 25,
            },
            {
                Key: "H",
                Value: 12,
            },
            ]
            const extention = "Parcel.xlsx"
            let excelSheetData = []

            postApi("Parcel/list", {
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                CreatedBy: parseInt(userFilter),
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.ParcelList.length; index++) {
                        let dataObj = {
                            Name: data?.ParcelList[index].Name,
                            CourierPartner: data?.ParcelList[index].CourierPartner,
                            Amount: Math.round(data?.ParcelList[index].Amount).toFixed(2),
                            CreatedByName: data?.ParcelList[index].CreatedByName,
                            Qty: data?.ParcelList[index].Qty,
                            PayOrDue: data?.ParcelList[index].PayOrDue ? "Pay" : "Due",
                            Remark: data?.ParcelList[index].Remark,
                            CreatedOn: data?.ParcelList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.ParcelList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })
            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <ParcelTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddParceLList={true}
                            handleParcelClick={handleParcelClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            writeDataToExcel={writeDataToExcel}
                            totalAmount={totalAmount}
                        />

                        <CreateParcelModel
                            modal={modal}
                            toggle={toggle}
                            ParcelListApi={ParcelListApi}
                            isEdit={isEdit}
                            parcelData={parcelData}
                        />

                        <ParcelImagesUploadModel
                            modal={imageModal}
                            toggle={imageToggle}
                            parcelData={parcelData}
                            ParcelListApi={ParcelListApi}
                        />

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
ParcelList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default ParcelList
